<template>
  <Modal v-model="modal" :title="$t('name.address.active_address')" width="700" footer-hide scrollable>
    <div class="page-box">
      <Row type="flex" justify="space-between">
        <Col>
          <i-form inline>
            <FormItem>
              <Input v-model="where.name" :placeholder="$t('name.address.name')" style="width: 120px" />
            </FormItem>
            <FormItem>
              <Input v-model="where.phone" :placeholder="$t('name.address.phone')" style="width: 120px" />
            </FormItem>
            <FormItem>
              <Button type="primary" icon="md-search" :loading="loading" @click="search">{{ $t('name.search') }}</Button>
            </FormItem>
          </i-form>
        </Col>
        <Col>
          <Button type="primary" icon="md-apps" @click="getType" ghost>{{ $t('name.address.active_type') }}</Button> 
        </Col>
      </Row>
      <div class="scoped-empty" v-if="!list.length">{{ $t('message.empty') }}</div>
      <CellGroup @on-click="onClick">
        <template v-for="(item, key) in list">
          <Cell :name="key" :key="key">
            <span class="scoped-title">
              {{ item.name }} <Divider type="vertical" /> {{ item.phone }} {{ item.email }}
            </span>
            <span slot="label" class="scoped-lable">
              {{ item.address }} {{ item.number }}, {{ item.house }} {{ item.zip }} <b>{{ item.city }}</b>
            </span>
            <span slot="extra">
              <Tag v-if="item.type" type="border" color="primary">{{ $t('name.address.type') }}</Tag>
            </span>
          </Cell>
        </template>
      </CellGroup>
    </div>
  </Modal>
</template>
<script>
import { get } from '@/api/address'

export default {
  data() {
    return {
      loading: false,
      modal: false,
      list: [],
      where: {
        all: 1,
        type: null,
        name: null,
        phone: null
      }
    }
  },
  created() {
    this.getType()
  },
  methods: {
    open() {
      this.modal = true
    },
    getData() {
      this.loading = true
      get(this.where).then(res => {
        this.loading = false
        this.list = res
      })
    },
    getType() {
      // 重置搜索条件，取常用地址
      this.where.name = null
      this.where.phone = null
      this.where.type = 1
      this.getData()
    },
    search() {
      // 搜索全部
      this.where.type = null
      if(!this.where.name && !this.where.phone) {
        return this.$Message.warning(this.$t('message.empty'))
      }
      this.getData()
    },
    onClick(name) {
      this.$emit('click', Object.assign({}, this.list[name]))
      this.modal = false
    }
  },
};
</script>
<style lang="less" scoped>
  @import '@/style/app.less';
  
  .scoped-title{
    color: @color-content;
    line-height: 25px;
  }
  
  .scoped-lable{
    color: @color-sub;
    line-height: 25px;
    
    b {
      color: @color;
    }
  }
  
  .scoped-empty{
    padding: 50px;
    text-align: center;
    width: 100%;
  }
</style>